
import { Component } from "vue-property-decorator";
import { CreateElement } from "vue";
import AddEditNote from "@/components/app/admin/notes/addEditNote.vue";

@Component
export default class AddEditNoteModal extends AddEditNote {
  public render(h: CreateElement) {
    return h(
      "modal-card",
      {
        props: {
          title: this.$t("_action.edit_note")
        },
        on: {
          close: () => this.$emit("close")
        },
        scopedSlots: {
          footer: () =>
            h(
              "b-button",
              {
                props: {
                  type: "is-success",
                  loading: this.isProcessing
                },
                attrs: {
                  disabled: this.formIsDisabled
                },
                on: {
                  click: this.validateBeforeSubmit
                }
              },
              [this.$t("_action.save") as string]
            )
        }
      },
      [
        // Render parent template as child of this
        // @ts-ignore
        this.constructor.superOptions.render.call(this, h)
      ]
    );
  }
}
